import { render } from "./ImportPage.vue?vue&type=template&id=2bfa19d8"
import script from "./ImportPage.vue?vue&type=script&lang=js"
export * from "./ImportPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/macbook/Documents/freelance/naks/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__